// JavaScript source code
import React from "react";
import "./css/AboutUs.css"; // Reusing the same modern styles
import pictureOne from "./assets/picOne.png";

const ProductCertification = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header certification-header">
        <div className="overlay">
          <h1 className="page-title">Product and Service Certification</h1>
          <p className="subtitle">
            Promoting consumer confidence and fair trade through certified quality and compliance.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About Certification Services</h2>
          <p>
            The Malawi Bureau of Standards (MBS) operates the Product and Service Certification Scheme 
            to ensure that products and services offered in Malawi meet established national and 
            international standards. Through certification, MBS assures consumers and stakeholders 
            of quality, safety, and consistency.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Objective</h2>
          <p>
            To enhance industrial competitiveness, protect consumers, and promote fair trade by 
            certifying products and services that comply with Malawi Standards and relevant 
            international specifications.
          </p>
        </div>
      </section>

      {/* === Types of Certification === */}
      <section className="functions-section">
        <h2>Types of Certification Offered</h2>
        <ul>
          <li>
            <strong>Product Certification:</strong> 
            This involves testing and auditing of manufacturing processes to ensure that products 
            consistently meet quality and safety requirements. Certified products are authorized 
            to carry the <em>MBS Certification Mark</em>, symbolizing trust and compliance.
          </li>
          <li>
            <strong>Service Certification:</strong> 
            MBS also certifies service providers — such as laboratories, inspection bodies, and 
            hospitality institutions — ensuring their systems and operations meet national and 
            international benchmarks for service delivery.
          </li>
          <li>
            <strong>Import and Export Certification:</strong> 
            The Bureau provides pre-shipment and consignment testing and certification services 
            to facilitate international trade and ensure products entering or leaving Malawi meet 
            regulatory requirements.
          </li>
        </ul>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of MBS Certification</h2>
        <ul>
          <li>Enhances consumer confidence and product credibility.</li>
          <li>Facilitates access to regional and international markets.</li>
          <li>Improves organizational processes and product quality.</li>
          <li>Supports compliance with legal and regulatory frameworks.</li>
          <li>Promotes fair competition among manufacturers and service providers.</li>
        </ul>
      </section>

      {/* === Background and Mandate === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            Established under the Standards Act of 1972 (amended in 2012), the MBS is mandated 
            to promote standardization, quality assurance, metrology, and certification in Malawi. 
            The certification function forms a cornerstone of the Bureau’s quality infrastructure, 
            safeguarding both consumers and industry.
          </p>

          <h2>Mandate</h2>
          <p>
            To operate certification schemes that assess, verify, and recognize products and services 
            for conformity to established standards — thus fostering quality culture and protecting 
            public health and safety.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="MBS Certification Services" />
        </div>
      </section>

      {/* === Accreditation Section === */}
      <section className="benefits-section">
        <h2>Accreditation and Recognition</h2>
        <p>
          MBS certification schemes are recognized nationally and regionally through collaborations 
          with organizations such as the Southern African Development Community Accreditation Service (SADCAS) 
          and the African Organisation for Standardisation (ARSO). This ensures that MBS-certified 
          products are trusted and accepted beyond Malawi’s borders.
        </p>
      </section>
    </div>
  );
};

export default ProductCertification;
